import linkTypes from './link-types';

export default {
  linkType: linkTypes.EXTERNAL,
  reference: '#',
};
